import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./style.css";
import Modal from "react-bootstrap/Modal";
import ProgressBar from "react-bootstrap/ProgressBar";
import Button from "components/Button/Button";
import { Category_list_Api, HeaderConfig, environment, user_entity_uuid, myHeaders_Autorized, myHeaders_Auth_With_Cache_Control, user_API } from "Api/Api";
import axios from "axios";
import EmptyMessage from "components/EmptyMessage/EmptyMessage";
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import globe from "Assets/planet-space-world.png";
import { saveKey, current_unix_stamp, origin } from "utils/Helper";
import { local_routes } from 'utils/Routes';
const User_Patch_Api = environment.User_Patch_Api;

let cat_Image =
  "https://images.unsplash.com/photo-1466584241662-8cb021032c1a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80";
let ItemsSelected, ItemsSelectedData;

class CategoryModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Categories: [],
      checked: false,
      loading: true,
      ModalBodyStatus: 0,
      SelectedDataLength: 0,
      Def_Cat_Len: 3,
      Items_Selection_left: 3,
      prog: 0,
      //prog: 100,
      ModalLoader: false,
      originData:null
    };
  }

  // Checkbox toggle functionality
  onToggle(index) {
    let newItems = this.state.Categories.slice();
    newItems[index].checked = !newItems[index].checked;
    this.setState({ Categories: newItems });
    ItemsSelected = JSON.stringify(
      this.state.Categories.filter(item => item.checked)
    );
    ItemsSelectedData = JSON.parse(ItemsSelected);
    this.setState({
      SelectedDataLength: ItemsSelectedData.length,
      Items_Selection_left: this.state.Def_Cat_Len - ItemsSelectedData.length
    });
  }

  // Code to close modal
  onCloseModal = () => {
    this.setState({ setModalShow: false });
  };

  componentDidMount() {
    let originData = localStorage.getItem('loginOrigin');
    this.setState({ setModalShow: this.props.setModalShow,originData:originData  });
    saveKey("First_Time_Status", 0);
    // API Call for showing categories
    axios
      .get(Category_list_Api, HeaderConfig)
      .then(response => {
        let carImageProcessedTempArr=[];
        response.data.entities.forEach((item,index)=>{
          if(item.image_url !== undefined){
            let url = item.image_url;
            let array = url.split("/");
            carImageProcessedTempArr[index]={
              created_time:item.created_time,
              description:item.description,
              entity_name:item.entity_name,
              entity_uuid:item.entity_uuid,
              friendly_url:item.friendly_url,
              image_url:`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/360x365/${array[5]}`,
              last_updated_time:item.last_updated_time,
              legacy_oid:item.legacy_oid
            }
          }
          else
          {
            carImageProcessedTempArr[index]={
              created_time:item.created_time,
              description:item.description,
              entity_name:item.entity_name,
              entity_uuid:item.entity_uuid,
              friendly_url:item.friendly_url,
              image_url:item.image_url,
              last_updated_time:item.last_updated_time,
              legacy_oid:item.legacy_oid
            }
          }
          
        })
        this.setState({ Categories: carImageProcessedTempArr, loading: false });
      })
      .catch(()=> {
      });
  }

  /*
  componentDidUpdate() {
    // Code for stopping progress bar after 3 seconds
    if (this.state.prog === 100) {
      clearInterval(this.intervalId);
      const { originData } = this.state;
      if (originData === "pkCreation") {
        window.location.href = `${local_routes.pkcreation}`;
      }
      else {
        window.location.href = origin;
      }
    }
  }

  // Code for showing percentage starts
  PercentageInterval() {
    this.intervalId = setInterval(() => this.loadData(), 100);
    this.loadData();
  }
  loadData() {
    this.setState({ prog: this.state.prog + 1 });
    if (this.state.prog === 100) {
      this.setState({ setModalShow: false });
    }
  }
  // Code for showing percentage ends
  */

  // Code to show categories
  CatListChip = () => {
    return (
      <div className="modal-data">
        <div className="cat-List-Chip">
          <Row>
            {this.state.Categories.map((item, i) => (
              <Col key={i} sm={6} md={4} lg={3} className="pad0">
                <div
                  key={i}
                  className="listposition"
                  onChange={this.onToggle.bind(this, i)}
                >
                  <p className="contenthead">{item.entity_name}</p>
                  <label className="listposition">
                    <img
                      src={
                        item.image_url !== undefined || null
                          ? item.image_url
                          : cat_Image
                      }
                      alt="register-img"
                      className="img-fluid border-rds"
                    />
                    <div className="overlay"></div>
                    <input type="checkbox" className="checkboxposition" />
                  </label>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    );
  };

  // Code to show empty data
  _renderEmpty = () => {
    return <EmptyMessage empty_message="No Categories to show" />;
  };

  // Onclicking on category continue button
  OnClickInterestedCategory = () => {
    this.setState({ ModalLoader: true });
    let catTempArr = [];
    ItemsSelectedData.forEach(function (item) {
      catTempArr.push({
        xref_data: {
          favorited_time: current_unix_stamp
        },
        entity_uuid: item.entity_uuid
      });
    });
    let categories_Selected = { "categories.audience": catTempArr };

    axios
      .patch(
        `${User_Patch_Api}/${user_entity_uuid}`,
        JSON.stringify(categories_Selected),
        myHeaders_Autorized
      )
      .then( async () => {
        if (this.state.SelectedDataLength >= 3) {
          // Here calling GET Fav Categories for Cache-Control: max-age=0 starts 
          await axios.get(`${user_API}/${user_entity_uuid}/categories.audience`, myHeaders_Auth_With_Cache_Control);
          // Here Calling GET Fav Categories end
          const { originData } = this.state;
          if (originData === "pkCreation") {
            localStorage.removeItem('loginOrigin');
            window.location.href = `${local_routes.pkcreation}`;
          }
          else {
            window.location.href = origin;
          }
          //this.setState({loading: false, ModalBodyStatus: 1, ModalLoader: false });
        }
        //this.PercentageInterval();
      })
      .catch(() => {
        console.error("Error setting categories");
        this.setState({ ModalLoader: false });
      });
  };

  render() {
    const {
      loading,
      SelectedDataLength,
      Items_Selection_left,
      ModalBodyStatus,
      ModalLoader
    } = this.state;
    return (
      <div id="Category-Personalize-Modal">
        <Modal
          show={this.state.setModalShow}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          size={loading === true ? "sm" : "lg"}
          centered
        >
          <Modal.Body
            className={
              this.state.ModalBodyStatus === 0 ? "modal-Category-Body" : null
            }
          >
            {ModalBodyStatus === 0 ? (
              <div>
                {loading === true ? (
                  <ActivityIndicator theme="button-Status-Loader" />
                ) : (
                    <React.Fragment>
                      <div className="header">
                        <div className="modal-90w">
                          <h2>Follow all the categories you're interested in</h2>
                          <p>
                            Click on 3 or more categories to see PKs relating to
                        them.{" "}
                          </p>
                        </div>
                      </div>

                      <Container>
                        <div className="categories">
                          {this.state.Categories.length > 0
                            ? this.CatListChip()
                            : this._renderEmpty()}
                        </div>
                      </Container>

                      <div className="modal-90w">
                        <div className="footer-section">
                          <Row className="Footer-Row">
                            <Col lg={8} className="pad0">
                              <ProgressBar now={(SelectedDataLength === 1) ? 35 : (SelectedDataLength === 2) ? 70 : (SelectedDataLength >= 3) ? 100 : ''} />
                            </Col>
                            <Col lg={4} className="flex-end Footer-Btn pad0">
                              {ModalLoader === false ? (
                                <Button
                                  theme={
                                    SelectedDataLength < 3
                                      ? "btn-global btn-white-smoke font-small"
                                      : "btn-global btn-green font-small"
                                  }
                                  OnClickMet={
                                    SelectedDataLength < 3 ?
                                      null
                                      :
                                      this.OnClickInterestedCategory}
                                >
                                {SelectedDataLength < 3
                                  ? `${Items_Selection_left} more categories to continue`
                                  : "CONTINUE"}
                              </Button>
                            ) : (
                                <ActivityIndicator theme="button-Status-Loader" />
                              )}
                          </Col>
                        </Row>
                      </div>
                      </div>
                    </React.Fragment>
                  )}
              </div>
            ) : 
              (
                <Container>
                  <Row>
                    <div className="personalize-section" align="center">
                      <h2>Personalizing your experience...</h2>
                      <img src={globe} alt="Personalizing" />
                      <ProgressBar now={this.state.prog} />
                      <p>Get ready to get inspired!</p>
                    </div>
                  </Row>
                </Container>
              )
            }
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

/* // old progress bar code
              (
                <Container>
                  <Row>
                    <div className="personalize-section" align="center">
                      <h2>Personalizing your experience...</h2>
                      <img src={globe} alt="Personalizing" />
                      <ProgressBar now={this.state.prog} />
                      <p>Get ready to get inspired!</p>
                    </div>
                  </Row>
                </Container>
              )
*/

export default CategoryModal;
